import { Component, Input, ViewEncapsulation } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { NavService, Menu } from '../../services/nav.service';
import { OappService } from '../../services/oapp.service'
import { NetsolinService } from '../../services/netsolin.service';
import { AuthService } from '../../services/firebase/auth.service';
//Modelo
import { CustomizerService } from '../../services/customizer.service';
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SidebarComponent {

  public menuItems: Menu[];
  public subMenuKey: String
  public subMenuItems: Menu[];
  public url: any;
  public fileurl: any;
  public modulos: any; //Modulos Netsolin
  public selected: any;


  private cargoMenuPredef = false;
  public cargoerpmenu = false;
  public firstLevel = true;

  constructor(private router: Router, public navServices: NavService, private netsolinService: NetsolinService, public customize: CustomizerService,
    public authService: AuthService
    ) {
    this.navServices.items.subscribe(async (menuItems) => {
      this.menuItems = menuItems
      console.log('menu items', menuItems);
      console.log('navServices',navServices);
      this.selected = this.router.url
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          this.selected = event.url;
          this.setNavActive(event.url);
        }
      })
    })
  }

  backToFirst() {
    this.firstLevel = true;
    this.customize.data.settings.sidebar.type = 'compact-wrapper';
    this.customize.data.settings.sidebar.body_type = 'sidebar-icon';
    this.setNavActive('nan')
  }

  setNavActive(path) {
    console.log("searching for", path, this.selected);

    this.menuItems.map((item) => {
      let find1 = false;
      item.children ? item.children.map(children => {
        let find2 = false;
        children.children ? children.children.map(child => {
          let find3 = false
          child.children ? child.children.map(subchild => {
            subchild.active = (subchild.title == path && !subchild.active) || subchild.path == path || subchild.path == this.selected;
            find3 = find3 || subchild.active;
          }) : '';
          child.active = find3 || (child.title == path && !child.active) || child.path == path || child.path == this.selected;
          find2 = find2 || child.active;
        }) : '';
        children.active = find2 || (children.title == path && !children.active) || children.path == path || children.path == this.selected;
        find1 = find1 || children.title == path || children.active;
      }) : '';
      item.active = find1 || (item.title == path && !item.active) || item.path == path || item.path == this.selected;
      if (find1) {

      }
    })
  }

  toggleActive(item) {
    console.log(item);

    if (item.type == 'link') {
      this.router.navigate([item.path]);
      this.selected = item.path;
    }
    else if (item.type == 'extLink') {
      document.location.href = item.path
    }
    else if (item.type == 'extTabLink') {
      window.open(item.path, "_blank")
    }
    this.setNavActive(item.title)
    if (this.firstLevel && item.type == 'sub') {
      this.firstLevel = false;
      this.customize.data.settings.sidebar.type = 'default';
      this.customize.data.settings.sidebar.body_type = 'default';
      this.subMenuItems = item.children;
      this.subMenuKey = item.title;
    }
  }

  //Fileupload
  readUrl(event: any) {
    if (event.target.files.length === 0)
      return;
    //Image upload validation
    var mimeType = event.target.files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      return;
    }
    // Image upload
    var reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (_event) => {
      this.url = reader.result;
    }
  }
}
